import React from 'react';
import PropTypes from 'prop-types';

import { withHoverPopup } from 'components/_HOC_';
import CircleButton from '../../../../CircleButton';
import ButtonPopupMessage from '../ButtonPopupMessage';

const UnselectedFill = '#696F88';
const SelectedFill = '#FFFFFF';
const DisabledFill = '#A0AEC0';

const PolygonIcon = ({ selected = false, disabled = false }) => {
  let fill;

  if (disabled) {
    fill = DisabledFill;
  } else {
    fill = selected ? SelectedFill : UnselectedFill;
  }

  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7143 11.4286C13.7018 11.4286 13.6904 11.4321 13.6779 11.4321L12.2779 9.09929C12.4589 8.77179 12.5714 8.40071 12.5714 8C12.5714 7.59929 12.4593 7.22821 12.2779 6.90071L13.6779 4.56786C13.6904 4.56821 13.7018 4.57143 13.7143 4.57143C14.9768 4.57143 16 3.54821 16 2.28571C16 1.02321 14.9768 0 13.7143 0C12.8704 0 12.1414 0.4625 11.7457 1.14286H4.25429C3.85857 0.4625 3.12964 0 2.28571 0C1.02321 0 0 1.02321 0 2.28571C0 3.12964 0.4625 3.85857 1.14286 4.25429V11.7454C0.4625 12.1414 0 12.8704 0 13.7143C0 14.9768 1.02321 16 2.28571 16C3.12964 16 3.85857 15.5375 4.25429 14.8571H11.7454C12.1414 15.5375 12.87 16 13.7139 16C14.9764 16 15.9996 14.9768 15.9996 13.7143C16 12.4518 14.9768 11.4286 13.7143 11.4286ZM3.42857 11.7457V4.25429C3.77084 4.05541 4.05541 3.77084 4.25429 3.42857H11.6957L10.3221 5.71786C10.3096 5.7175 10.2982 5.71429 10.2857 5.71429C9.02321 5.71429 8 6.7375 8 8C8 9.2625 9.02321 10.2857 10.2857 10.2857C10.2982 10.2857 10.3096 10.2821 10.3221 10.2821L11.6957 12.5714H4.25429C4.05551 12.2291 3.77091 11.9445 3.42857 11.7457ZM9.71429 8C9.71429 7.685 9.97071 7.42857 10.2857 7.42857C10.6007 7.42857 10.8571 7.685 10.8571 8C10.8571 8.315 10.6007 8.57143 10.2857 8.57143C9.97071 8.57143 9.71429 8.315 9.71429 8ZM14.2857 2.28571C14.2857 2.60071 14.0293 2.85714 13.7143 2.85714C13.3993 2.85714 13.1429 2.60071 13.1429 2.28571C13.1429 1.97071 13.3993 1.71429 13.7143 1.71429C14.0293 1.71429 14.2857 1.97071 14.2857 2.28571ZM2.28571 1.71429C2.60071 1.71429 2.85714 1.97071 2.85714 2.28571C2.85714 2.60071 2.60071 2.85714 2.28571 2.85714C1.97071 2.85714 1.71429 2.60071 1.71429 2.28571C1.71429 1.97071 1.97071 1.71429 2.28571 1.71429ZM1.71429 13.7143C1.71429 13.3993 1.97071 13.1429 2.28571 13.1429C2.60071 13.1429 2.85714 13.3993 2.85714 13.7143C2.85714 14.0293 2.60071 14.2857 2.28571 14.2857C1.97071 14.2857 1.71429 14.0293 1.71429 13.7143ZM13.7143 14.2857C13.3993 14.2857 13.1429 14.0293 13.1429 13.7143C13.1429 13.3993 13.3993 13.1429 13.7143 13.1429C14.0293 13.1429 14.2857 13.3993 14.2857 13.7143C14.2857 14.0293 14.0293 14.2857 13.7143 14.2857Z"
        fill={fill}
      />
    </svg>
  );
};

PolygonIcon.propTypes = { selected: PropTypes.bool, disabled: PropTypes.bool };

const CircleIcon = ({ selected = false, disabled = false }) => {
  let fill;

  if (disabled) {
    fill = DisabledFill;
  } else {
    fill = selected ? SelectedFill : UnselectedFill;
  }

  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10982 14.5703C3.87823 13.9188 2.11839 12.1612 1.46371 9.93099C0.62033 9.70227 0 8.93139 0 8.01562C0 7.10343 0.615494 6.335 1.45384 6.10296C2.10056 3.85661 3.86691 2.08448 6.10982 1.42966C6.34983 0.603685 7.11223 0 8.01562 0C8.91542 0 9.67534 0.598878 9.91853 1.41978C12.1964 2.07189 13.9882 3.87482 14.6246 6.15928C15.3737 6.443 15.9062 7.16712 15.9062 8.01562C15.9062 8.86784 15.369 9.59457 14.6148 9.87567C13.9699 12.1436 12.1848 13.9314 9.91853 14.5802C9.67534 15.4011 8.91542 16 8.01562 16C7.11223 16 6.34983 15.3963 6.10982 14.5703ZM8.01562 2.5C8.3004 2.5 8.53125 2.26915 8.53125 1.98438C8.53125 1.6996 8.3004 1.46875 8.01562 1.46875C7.73085 1.46875 7.5 1.6996 7.5 1.98438C7.5 2.26915 7.73085 2.5 8.01562 2.5ZM8.01562 3.96875C8.74222 3.96875 9.37761 3.57824 9.72335 2.99564C11.2596 3.51489 12.479 4.72167 13.0156 6.24982C12.3754 6.57905 11.9375 7.2462 11.9375 8.01562C11.9375 8.7813 12.3712 9.44569 13.0062 9.77659C12.465 11.2922 11.2507 12.4881 9.72335 13.0044C9.37761 12.4218 8.74222 12.0312 8.01562 12.0312C7.29272 12.0312 6.6601 12.4178 6.31319 12.9955C4.77322 12.466 3.55513 11.2444 3.03035 9.70227C3.59369 9.35217 3.96875 8.7277 3.96875 8.01562C3.96875 7.29988 3.58982 6.67265 3.02162 6.32359C3.54154 4.76923 4.76462 3.53697 6.31319 3.0045C6.6601 3.58219 7.29272 3.96875 8.01562 3.96875ZM13.9219 8.53125C14.2066 8.53125 14.4375 8.3004 14.4375 8.01562C14.4375 7.73085 14.2066 7.5 13.9219 7.5C13.6371 7.5 13.4062 7.73085 13.4062 8.01562C13.4062 8.3004 13.6371 8.53125 13.9219 8.53125ZM2.5 8.01562C2.5 8.3004 2.26915 8.53125 1.98438 8.53125C1.6996 8.53125 1.46875 8.3004 1.46875 8.01562C1.46875 7.73085 1.6996 7.5 1.98438 7.5C2.26915 7.5 2.5 7.73085 2.5 8.01562ZM8.53125 14.0156C8.53125 14.3004 8.3004 14.5312 8.01562 14.5312C7.73085 14.5312 7.5 14.3004 7.5 14.0156C7.5 13.7309 7.73085 13.5 8.01562 13.5C8.3004 13.5 8.53125 13.7309 8.53125 14.0156Z"
        fill={fill}
      />
    </svg>
  );
};
CircleIcon.propTypes = { selected: PropTypes.bool, disabled: PropTypes.bool };

const DrawModeToggle = ({
  modes,
  modeSelected,
  mode,
  icon: Icon,
  ariaLabel,
  overlay = null
}) => {
  const active = mode === modes[1];
  return (
    <CircleButton
      onClick={() => (active ? modeSelected(modes[0]) : modeSelected(modes[1]))}
      selected={active}
      disabled={!!overlay}
      ariaLabel={ariaLabel}
    >
      <Icon selected={active} disabled={!!overlay} />
    </CircleButton>
  );
};

DrawModeToggle.propTypes = {
  modes: PropTypes.arrayOf(PropTypes.string).isRequired,
  modeSelected: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  overlay: PropTypes.string
};

const DrawPolygonButton = withHoverPopup(
  ({ modeSelected, mode, overlay }) => (
    <DrawModeToggle
      overlay={overlay}
      modes={['simple_select', 'draw_polygon']}
      modeSelected={modeSelected}
      mode={mode}
      ariaLabel="Draw Polygon"
      icon={PolygonIcon}
    />
  ),
  <ButtonPopupMessage message="Draw Polygon" hotkey="p" />,
  { position: 'left', ariaLabel: 'Draw Polygon (p)', top: '-0.25rem' }
);

const DrawCircleButton = withHoverPopup(
  ({ modeSelected, mode, overlay }) => (
    <DrawModeToggle
      overlay={overlay}
      modes={['simple_select', 'drag_circle']}
      modeSelected={modeSelected}
      mode={mode}
      ariaLabel="Draw Circle"
      icon={CircleIcon}
    />
  ),
  <ButtonPopupMessage message="Draw Circle" hotkey="c" />,
  { position: 'left', ariaLabel: 'Draw Circle (c)', top: '-0.25rem' }
);

const DrawModeButtons = ({ mode, modeSelected, overlay = null }) => {
  return (
    <div className="flex flex-col" data-testid="draw-mode-buttons">
      <DrawPolygonButton
        mode={mode}
        modeSelected={modeSelected}
        overlay={overlay}
      />
      <DrawCircleButton
        mode={mode}
        modeSelected={modeSelected}
        overlay={overlay}
      />
    </div>
  );
};

DrawModeButtons.propTypes = {
  modeSelected: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  overlay: PropTypes.string
};

export default DrawModeButtons;
